<template>
  <main class="science">
    <!-- Banner -->
    <section class="banner banner--model banner--model__prime" style="min-height:250px;">
      <div class="mask"></div>
    </section>
    <section class="banner banner--form">
      <div class="container">
          <h2 id="prime">Tackling the industry's top issues</h2>
          <p>If you are not familiar with the American transportation industry, you might not know that a shortage of drivers and driver turnover are massive challenges it faces. The American Transportation Research Academy (ATRI) recently released the Top Industry Issues report for 2018, which showed that the driver shortage is the top issue faced by transportation professionals, while driver retention ranks number three <sup>1</sup>.  To outperform its competitors, a carrier must solve both of these problems in its operations.</p>
<p>Prime, Inc., one of the largest carriers in the nation, is taking exactly this strategy to grow. It runs one of the most well-known and successful driver training programs in North America. By developing well-trained drivers, Prime is a significant contributor to addressing the industry-wide labor shortage.</p>
<p>However, keeping new drivers is a significant challenge for any carrier. As driver retention solutions firm Stay Metrics recently reported, drivers with less than 1 year of industry experience were significantly more likely to have thought about leaving their current carrier in 2018 <sup>2</sup>.  Newly trained drivers are highly vulnerable to leaving their carrier early on, so Prime needed to find a way to help these drivers feel connected to the company’s culture to reduce this risk.</p>
<p><strong>The solution</strong>: put forward Prime's best assets—its people.</p>

      </div>
      <div class="container">
          <h2 id="matching">Matching driver trainees with trainers by values </h2>
         <p> The most important relationship trainees build at Prime is with their trainers. These instructors accompany them on the road and share invaluable industry experience and insights. If this relationship is strong, trainees form a positive view of the carrier. </p>
<p>This key relationship works both ways, though. If trainers and trainees hold significantly different values, miscommunications and misunderstandings can occur. If these issues come up, trainees are more likely to leave the company at the first opportunity.</p>
<p>To solve this issue, Prime's driver retention partner Stay Metrics introduced the carrier to Twegos, an HR People Analytics software platform that matches people, teams, and managers based on value-fit. This unique method of assessment evaluates what respondents want in their life and work.</p>
<p>In contrast to personality-based testing, values tend to be more stable over time. The kind of things you want as a person and professional tend to be stable even if you make significant career shifts in your lifetime. These values include factors like if you care more about recognition or opportunities for self-development in your job, or whether you value collaboration or autonomy.</p>
<p>Once Prime tests trainers and trainees, Twegos' auto-matching system pairs them based on the best possible value-fit. Prime's custom model also takes into account objective criteria, such as drivers' region, gender, smoking behavior, and vehicle type.</p>


      </div>
      <div class="container">
          <h2 id="matching">Improved retention based on value-fit</h2>
         <p>After the initial 200 days, the results of this digital matching based on value-fit were tested. Only 18% of drivers matched with a highly compatible trainer had left the company. Over the same period, 37% of trainees with a poor trainer match turned over.</p>
  <center>
  <img src="/static/graph.png" width="70%" style="min-width:350px">
  </center>
 
<p>Jim Guthrie, Operations Manager at Prime, confirms the outcome: "At Prime, Inc., we invest in technology that helps us improve our service and ensure safe, timely delivery for every customer; but we also invest in enhancing the quality of life for our driver associates. The value-fit matching of trainers with trainees has not only helped reduce early driver turnover but also challenged more of our drivers to take on the role of instructor."
</p>


      </div>
      <div class="container">
          <h2 id="matching">Happier drivers all over the USA</h2>
         <p>After this initial step, Prime continues its push toward becoming a value-driven organization. Its team has plans to roll out Twegos’ Auto-Match tool full scale at facilities in Utah and Pennsylvania in the near future. By matching drivers based on values, Prime is getting more happier drivers out on the road, increasing their capacity and revenue.</p>


      </div>
      <div class="container">
        
          <div class="form">
            
            <!-- Form request components -->
            <form-request 
              :originForm="section"
              :ctaLabel="home.formRequestPaper.cta">
            </form-request>
          
        </div>
      </div>
      <div class="container" style="font-size:10px">
            <p><sup>1</sup>American Transportation Research Institute (2018). "Driver Shortage Once Again Ranked as Trucking Industry’s Top Concern."<br>Retrieved from: <a href="https://truckingresearch.org/2018/10/29/driver-shortage-once-again-ranked-as-trucking-industrys-top-concern/#.XHladIhKiM8" target="_blank">https://truckingresearch.org/2018/10/29/driver-shortage-once-again-ranked-as-trucking-industrys-top-concern/#.XHladIhKiM8</a> </p>
      <p><sup>2</sup>Stay Metrics (2019). "Stay Data Story: Driver Intent to Leave in 2018."<br>Retrieved from: <a href="http://go.staymetrics.com/staydatastory" target="_blank">http://go.staymetrics.com/staydatastory</a> </p>

      </div>
      <div class="mask"></div>
    </section>
   
  </main>
</template>

<script>
import Home from '@/contents/homepage.json'
import How from '@/contents/how.json'
import Usps from '@/components/Usps.vue'
import FormRequest from '@/components/Form.vue'
export default {
  components: {
    Usps,
    FormRequest
  },
  name: 'How',
  props: ['mobile'],
  data () {
    return {
      section: this.$options.name,
      how: How,
      home: Home,
      isSticky: false,
      ticking: false,
      lastPositionScroll: 0
    }
  },
  methods: {
    setStickyClass (positionScroll) {
      let elm = document.querySelector('.banner--model')
      let heightElm = elm.clientHeight
      if (positionScroll >= heightElm) {
        this.isSticky = true
      } else {
        this.isSticky = false
      }
    }
  },
  mounted () {
    window.addEventListener('scroll', (e) => {
      this.lastPositionScroll = window.scrollY
      if (!this.ticking) {
        window.requestAnimationFrame(() => {
          this.setStickyClass(this.lastPositionScroll)
          this.ticking = false
        })
      }
      this.ticking = true
    })
  }
}
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/pages/primecase.vue